import InvitationPost from '@/components/invitation-post/InvitationPost.vue'
import vSelect from 'vue-select'
import { BPaginationNav, BPagination } from 'bootstrap-vue'
import '@/scripts/vue/dayjs'
import VueScrollTo from 'vue-scrollto'
import fetchItems from '@/scripts/vue/api-axios'
import ListStateMixin from '@/mixins/ListStateMixin'

const categoryId = typeof window.category_id === "undefined" ? 4 : window.category_id
const perPageInitial = typeof window.perPageInitial === "undefined" ? 10 : window.perPageInitial

const invitationsListConfig = {
    mixins: [ListStateMixin('invitationList')],
    components: {
      InvitationPost,
      vSelect,
      BPaginationNav,
      BPagination
    },
    mounted() {
      this.$Progress.start();
      fetchItems(`/yiifchallenges?categoryId=${categoryId}`)
        .then((items) => {
          this.invitations = items;
        })
        .then(() => {
          fetchItems(`/yiifcategory/challenges`)
            .then((items) => {
              this.scrollTo('body', 0);

              this.categories = items;
              this.getSelectOptions();
              this.$Progress.finish();

              // sort attribute from url
              this.sortingType = 0;
              const sortParam = parseInt(window.utils.getQueryStringParameter('callsSort'));
              if ( sortParam )
              {
                this.sortingType = sortParam;
              }

              // category attribute from url
              const categoryParam = parseInt(window.utils.getQueryStringParameter('callsCategory'));
              if ( categoryParam )
              {
                const currentCategory = this.selectOptions.filter(option => {
                  return option.id === categoryParam
                });

                this.selectedCategory = currentCategory[0];
              }

              // pagination attribute from url
              const pageParam = window.utils.getQueryStringParameter('callsPage');
              if ( pageParam )
              {
                this.currentPage = pageParam;
              }

            })
        });
      //this.sortingType = 0;
    },
    data: () => ({
      invitations: [],
      categories: [],
      selectOptions: [],
      selectedCategory: null,
      currentPage: 1,
      perPage: perPageInitial,
      sortingType: null,
      scrollerIsScrolling: false
    }),
    computed: {
      itemsForList() {
        return this.filteredItems.slice(
          (this.currentPage - 1) * this.perPage,
          this.currentPage * this.perPage,
        );
      },
      rows() {
        return this.filteredItems.length
      },
      filteredItems() {
        return this.invitations
          .sort((a, b) => {
            return this.sortingType === 0
              ? this.$date(a.dateOpening).isBefore(b.dateOpening, 'day') ? -1 : 1
              : this.$date(a.dateClosing).isBefore(b.dateClosing, 'day') ? -1 : 1
          })
          .filter(item => {
            if (!this.selectedCategory || !this.selectedCategory.id) return true;
            const articleCategories = new Set(Object.keys(item.category));
            const selectedCategories = this.selectedCategory.categories;
            for(let index = 0; index < selectedCategories.length; index++) {
              if (articleCategories.has(selectedCategories[index].toString())) return true
            }
          })
      },
      isOnePage() {
        return this.rows <= this.perPage
      }
    },
    methods: {
      getSelectOptions() {
        this.categories.map(segment => {
          this.selectOptions.push({
            id: segment.id,
            title: null,
            group: segment.title
          });
          if(segment.children.length !== 0) {
            segment.children.map(category => {
              this.selectOptions.push({
                id: category.id,
                title: category.title,
                categories: category.children,
              });
            })
          }
        });

        /* show all option */
        if ( this.$refs.categorySelect?.placeholder )
        {
          // get Ids of all categories
          const allCategoriesIds = this.categories.map(category => category.id);

          // get placeholder from ref select
          const placeholder = this.$refs.categorySelect.placeholder;

          // fill clear option, append it as first element and select by default (id 0 is what makes it show all categories)
          const clearOption = {
            categories: allCategoriesIds,
            id: 0,
            title: placeholder
          };

          this.selectOptions.unshift(clearOption);

          const defaultCategorySelected = parseInt(window.utils.getQueryStringParameter('callsCategory')) > 0; 
          if ( ! defaultCategorySelected )
          {
            this.selectedCategory = clearOption;
          }
        }
        /* ___ show all option ___ */
      },
      getPostLink(postCategories) {
        let link = postCategories[categoryId];
        if (this.selectedCategory && this.selectedCategory.id) {
          const categories = new Set(this.selectedCategory.categories);
          for (let key in postCategories) {
            if (categories.has(parseInt(key))) {
              return postCategories[key]
            }
          }
        }
        return link
      },
      scrollTo(target, duration) {
        // if not scrolling already
        if ( !this.scrollerIsScrolling )
        {
          // scroll to target with desired duration
          VueScrollTo.scrollTo(target, {
            duration: duration,
            onStart: () => {
              // set scrolling variable
              this.scrollerIsScrolling = true;
            },
            onDone: () => {
              // unset scrolling variable
              this.scrollerIsScrolling = false;
            }
          });
        }
      }
    },
    watch: {
      perPage: function() {
        this.scrollTo('body', 500);
      },
      currentPage: function(newValue, oldValue) {
        this.scrollTo('body', 500);

        // change query string after changing pagination
        if ( newValue != oldValue )
        {
          window.utils.setQueryStringParameter('callsPage', this.currentPage);
        }
      },
      sortingType: function(newValue, oldValue){
        if ( oldValue != newValue )
        {
          window.utils.setQueryStringParameter('callsSort', newValue);
        }
      },
      selectedCategory: function (newValue, oldValue) {

        if ( oldValue !== null && ( oldValue.id != newValue.id ) ) {
          this.currentPage = 1;
        }
  
        if ( newValue.id )
        {
          window.utils.setQueryStringParameter('callsCategory', newValue.id);
        }
        else
        {
          window.utils.setQueryStringParameter('callsCategory', 0);
        }

      }
    }
}

export default invitationsListConfig